import { render, staticRenderFns } from "./contactDetails.vue?vue&type=template&id=83ec642a&scoped=true"
import script from "./contactDetails.vue?vue&type=script&lang=js"
export * from "./contactDetails.vue?vue&type=script&lang=js"
import style0 from "./contactDetails.vue?vue&type=style&index=0&id=83ec642a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ec642a",
  null
  
)

export default component.exports